module.exports = "/_next/static/images/9354a2c846fca8e0c5218ce7fb94859c-roxinho-details-metalico-xs@1x.jpg";